import { HttpResponse } from './response.ts';
import { HttpRequest } from './request.ts';

export abstract class HttpMiddleware {
	abstract handle(request: HttpRequest, next: HttpHandler): Promise<HttpResponse>;
}

export interface HttpHandler {
	handle(request: HttpRequest): Promise<HttpResponse>;
}
